import { useState, useEffect } from "react";
import apiClient from "../../../shared/API/apiClient";

const validate = (name) => {
  const val = name.trim();
  if (!val) return "Department Name is required";
  if (val.length < 3) return "Department Name must be at least 3 characters";
  return "";
};

export default function DepartmentModal({ onClose, onSave, editData }) {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  // EDIT MODE DATA SET
  useEffect(() => {
    if (editData) {
      setName(editData.department_name || "");
    }
  }, [editData]);

  const handleChange = (e) => {
    setName(e.target.value);
    if (error) setError("");
  };

  const handleBlur = () => {
    const err = validate(name);
    if (err) setError(err);
  };

  const handleSubmit = async () => {
    const err = validate(name);
    if (err) {
      setError(err);
      return;
    }

    try {
      setSaving(true);

      // ADD API
      if (!editData) {
        await apiClient.post("/api/department-add", {
          name: name,
        });

        onSave(null, false); // Add
      }

      // UPDATE API (PUT)
      else {
        await apiClient.put(
          `/api/departments/${editData.department_id}`,
          {
            name: name,
          }
        );

        onSave(null, true); // Edit
      }
    } catch (err) {
      console.error("Department save error:", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>

        {/* HEADER */}
        <div className="modal-header">
          <div className="modal-title">
            {editData ? "Edit Department" : "Add Department"}
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {/* BODY */}
        <div className="modal-body">
          <div className="org-form-field">
            <label className="org-field-label">
              Department Name <span className="req">*</span>
            </label>

            <input
              className={`org-field-input ${
                error ? "org-field-input--error" : ""
              }`}
              placeholder="e.g. Operations"
              value={name}
              onChange={handleChange}
              onBlur={handleBlur}
            />

            {error && (
              <span className="org-field-error">{error}</span>
            )}
          </div>
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <button className="org-btn-cancel" onClick={onClose}>
            Cancel
          </button>

          <button
            className="org-btn-save"
            onClick={handleSubmit}
            disabled={saving}
          >
            {saving
              ? "Saving..."
              : editData
              ? "Update"
              : "Add"}
          </button>
        </div>

      </div>
    </div>
  );
}